import React, { FC } from 'react';

import { useFormContext } from 'old-rhf';

import { InputBaseProps, InputBase, getFieldError } from '@zazume/zzm-base';

import { useI18n } from '../../../hooks/useI18n';

interface InputProps extends InputBaseProps {
  onBlurValue?: (newValue: string) => void;
  onChangeValue?: (newValue: string) => void;
  isOptional?: boolean;
}

/**
 * @deprecated use ZZMForm.Input
 * @param props
 * @constructor
 */
export const Input: FC<InputProps> = props => {
  const { onBlurValue, onChangeValue, isOptional, ...inputProps } = props;

  const { t } = useI18n();
  const {
    register,
    formState: { errors }
  } = useFormContext();

  const error = getFieldError(props.name, errors);

  const handleOnBlur = (event: React.FormEvent<HTMLInputElement>) => onBlurValue?.(event.currentTarget.value);
  const handleOnChange = (event: React.FormEvent<HTMLInputElement>) => onChangeValue?.(event.currentTarget.value);

  const optionalText = isOptional ? t('general.optional') : undefined;

  return (
    <InputBase
      {...(inputProps as any)}
      ref={register({
        valueAsNumber: props.type === 'number'
      })}
      onChange={handleOnChange || inputProps.onChange}
      onBlur={handleOnBlur || inputProps.onBlur}
      error={error}
      responsive={props.responsive || false}
      optionalText={optionalText}
    />
  );
};
